export class Image {
    FileName: string;
    Location: string;
    Data: string;

    Id?: number;
}